import { SortObject } from "./../../../@types/sortObject";
import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";
import { sortOptions } from "../../../utils/sortOptions";
export const selectSortDocuments = createSelector(
  [(store: RootState) => store.documentsSignerList.sort],
  (sort) => {
    const result = sortOptions.find(({ value }) => value === sort) || ({} as SortObject);
    return result;
  }
);
